import React from "react";
import { motion } from "framer-motion";
import StorefrontIcon from "@mui/icons-material/Storefront";
import { StorefrontIconWrapper } from "./styles";

export interface KLStorefrontIconProps {
  /**
   * Size of the icon
   */
  size?: "small" | "medium" | "large";
  /**
   * Enable tap feedback animation (mobile-first)
   */
  animated?: boolean;
  /**
   * Add glow effect (recommended for large service icons)
   */
  withGlow?: boolean;
  /**
   * Use custom gradient styling
   */
  customStyle?: boolean;
}

const KLStorefrontIcon: React.FC<KLStorefrontIconProps> = ({
  size = "medium",
  animated = false,
  withGlow = true,
  customStyle = true,
}) => {
  const Component = animated ? motion.div : "div";

  return (
    <StorefrontIconWrapper
      as={Component}
      $size={size}
      $withGlow={withGlow && customStyle && size !== "small"}
      $customStyle={customStyle}
      role="img"
      aria-label="שירות עסקי"
      {...(animated
        ? {
            whileTap: { scale: 0.95 },
            transition: { type: "spring", stiffness: 300, damping: 20 },
          }
        : {})}
    >
      <StorefrontIcon />
    </StorefrontIconWrapper>
  );
};

export default KLStorefrontIcon;
